import {
  Components, Theme, buttonClasses, linkClasses, tabClasses,
} from '@mui/material';
import { Spacing4, Spacing6 } from '../spacing';
import {
  Content, Focused, Border, Primary,
} from '../color';
import { tabsClasses } from './types';
import getTransition from '../utilities/getTransition';

export const MuiTabs: Components<Theme>['MuiTabs'] = {
  styleOverrides: {
    root: {
      position: 'relative',
      [`&.${tabsClasses.divider}::after`]: {
        display: 'block',
        width: '100%',
        height: 4,
        backgroundColor: Border.variant.main,
        position: 'absolute',
        bottom: 0,
        left: 0,
        content: '""',
      },
      [`&.${tabsClasses.condensed} .${tabClasses.root}`]: {
        padding: Spacing4,
        minWidth: 0,
      },
    },
    indicator: {
      height: 4,
      zIndex: 1,
    },
  },
  defaultProps: {
    indicatorColor: 'secondary',
    textColor: 'secondary',
  },
};

export const MuiTab: Components<Theme>['MuiTab'] = {
  styleOverrides: {

    root: {
      zIndex: 2,
      padding: `${Spacing4} ${Spacing6}`,
      ...getTransition(['color']),
      ':hover': {
        color: Content.main,
      },
      [`&.${tabClasses.selected}`]: {
        color: Content.main,
      },
      [`&.${buttonClasses.focusVisible}`]: {
        outlineColor: Focused.main,
        outlineStyle: 'solid',
        outlineWidth: 2,
        outlineOffset: -2,
      },
      [`&.${linkClasses.root}`]: {
        minHeight: 48,
      },
    },
    textColorPrimary: {
      [`&.${tabClasses.selected}`]: {
        color: Primary.default.main,
      },
    },
  },
  defaultProps: {
    disableRipple: false,
    disableFocusRipple: true,
  },
};
